export const prerender = true;
export const ssr = false;
export const trailingSlash = 'always';
